import {Component, computed} from '@angular/core';
import {LoadingService} from '../../services/loading.service';

@Component({
  standalone: true,
  selector: 'app-loading',
  imports: [],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss'
})
export class LoadingComponent {
  constructor(private loadingService: LoadingService) {
  }

  isLoading = computed(() => this.loadingService.loading());
}
